import type { PeekViewService } from '@hive/core/modules/peek-view';
import { DebugLogger } from '@hive/debug';
import type {
  PeekOptions,
  PeekViewService as BSPeekViewService,
} from '@blocksuite/hive/components/peek';
import { PeekViewExtension } from '@blocksuite/hive/components/peek';
import type { TemplateResult } from 'lit';

const logger = new DebugLogger('hive::patch-peek-view-service');

export function patchPeekViewService(service: PeekViewService) {
  return PeekViewExtension({
    peek: (
      element: {
        target: HTMLElement;
        docId: string;
        blockIds?: string[];
        template?: TemplateResult;
      },
      options?: PeekOptions
    ) => {
      logger.debug('center peek', element);
      const { template, target, ...props } = element;

      return service.peekView.open(
        {
          element: target,
          docRef: props,
        },
        template,
        options?.abortSignal
      );
    },
  } satisfies BSPeekViewService);
}
